import React, { Component } from 'react'
import config from '../../../config'
import { Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap';
import errores from '../../../middleware/errordb';
import funciones from '../../../middleware/funciones';
import Mensajes from '../../subcomponent/mensajes'

import ModalConfirm from '../../subcomponent/modalConfirm';

export class bodegas extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            evento: 1,
            fecha: todayFormat,
            codigo: "1",
            estado: "1",
            descripcion: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            bodegas: [],
            mensaje: "",
            textButton: "Crear Bodega",
            isInv: 0,
            isVenta: 0
        }
    }

    componentDidMount() {
        this.infoBodegas();
    }

    infoBodegas = () => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/warehouse/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        const bodegas = datos[0];
                        const codigo = datos[1][0]["LAST_COD"];
                        this.setState({
                            bodegas,
                            codigo,
                            controlCodigo: codigo
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Sin bodega creadas" })
                    }
                });
        }
    }

    createwarehouse = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();
        const { evento } = this.state
        const { codigo } = this.state
        const { descripcion } = this.state
        const { estado } = this.state
        const { empresa } = this.state
        const { isInv } = this.state
        const { isVenta } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                CODIGO_BODEGA: codigo,
                DESCRIPCION_BODEGA: descripcion,
                ESTADO_BODEGA: estado,
                AFECTA_INVENTARIO: isInv,
                VENTA: isVenta
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        let url = "";
        if (evento) {
            url = "/warehouse/create/";
        } else {
            url = "/warehouse/modify/"
        }
        fetch(config.servBackEnd + url, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoBodegas();
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", descripcion: "", estado: "1", evento: 1, isInv: 0, isVenta: 0, textButton: "Crear Bodega" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en bodega: " + errores[data.code] + " " + data.message })
                }
            });
        //});
    }

    editWare = (selected) => {
        this.setState({
            codigo: selected.CODIGO_BODEGA,
            descripcion: selected.DESCRIPCION_BODEGA,
            estado: selected.ESTADO_BODEGA,
            isInv: selected.AFECTA_INVENTARIO,
            isVenta: selected.VENTA,
            evento: 0,
            textButton: "Modificar Bodega"
        })
    }
    cleanForm = () => {
        const { controlCodigo } = this.state;
        this.setState({
            codigo: controlCodigo,
            descripcion: "",
            estado: "1",
            evento: 1,
            isInv: 0,
            isVenta: 0,
            textButton: "Crear Bodega"
        })
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const { bodegas } = this.state;
        const editWare = this.editWare;
        const mensajeConfirm = (this.state.evento) ? '¿Está seguro que desea crear la bodega?' : '¿Está seguro que desea modificar la bodega?';
        return (
            <div>

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Bodegas</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createwarehouse}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Codigo</Form.Label>
                                        <Form.Control type="text" value={this.state.codigo} required readOnly />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Descripcion</Form.Label>
                                        <Form.Control type="text" onChange={e => this.setState({ descripcion: e.target.value })} value={this.state.descripcion} required />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Afecta Inventario</Form.Label>
                                        <Form.Check type="checkbox" checked={this.state.isInv} onChange={e => this.setState({ isInv: e.target.checked })} ></Form.Check>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Bodega para venta</Form.Label>
                                        <Form.Check type="checkbox" checked={this.state.isVenta} onChange={e => this.setState({ isVenta: e.target.checked })} ></Form.Check>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required >
                                            <option value="1">ACTIVO</option>
                                            <option value="0">INACTIVO</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                {!this.state.evento && <Button className="m-3" variant="primary" onClick={this.cleanForm}>Limpiar</Button>}
                                <Button className="m-3" variant="primary" type="submit">{this.state.textButton}</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="contenedor">
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Afecta Inventario</th>
                                <th>Para la venta</th>
                                <th>Estado</th>
                                <th colSpan="2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bodegas.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td>{currentData.ID_EMPRESA}</td>
                                    <td>{currentData.CODIGO_BODEGA}</td>
                                    <td>{currentData.DESCRIPCION_BODEGA}</td>
                                    <td>{funciones.textEstadoGeneral(currentData.AFECTA_INVENTARIO)}</td>
                                    <td>{funciones.textEstadoGeneral(currentData.VENTA)}</td>
                                    <td>{funciones.textEstadoGeneral(currentData.ESTADO_BODEGA)}</td>
                                    <td><Button onClick={() => editWare(currentData)} variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}

export default bodegas



// WEBPACK FOOTER //
// ./src/components/bussines/inventarios/bodegas.jsx